import { render } from "./UserQuickSetup.vue?vue&type=template&id=31706390&scoped=true&ts=true"
import script from "./UserQuickSetup.vue?vue&type=script&lang=ts"
export * from "./UserQuickSetup.vue?vue&type=script&lang=ts"

import "./UserQuickSetup.vue?vue&type=style&index=0&id=31706390&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31706390"]])

export default __exports__